import Home from './index.vue'
export default Home